import SC from 'styled-components'

export const Wrapper = SC.div`
  padding: 20px 30px 32px;
`
